import { Controller } from '@hotwired/stimulus';
import { openModalByUrl } from '../utilities/modal';

export default class extends Controller {
    static targets = ["consentButton", "checkbox"]

    static values = {
        consentUrl: String,
        canAccept: Boolean
    }

    generateConsentContent(event) {
        event.preventDefault();

        let checkbox = null;
        let consentKey = null;

        if (event.target.type === 'checkbox') {
            checkbox = event.target;
            consentKey = checkbox.dataset.consentKey;

            if (!checkbox.checked) {
                return;
            }
        } else {
            consentKey = event.currentTarget.dataset.consentKey;
        }

        if (this.consentUrlValue) {
            let url = this.consentUrlValue;

            if (checkbox) {
                checkbox.checked = false;
            }

            url += (url.includes('?') ? '&' : '?') + `content_key=${encodeURIComponent(consentKey)}`;
            url += (url.includes('?') ? '&' : '?') + `can_accept=${encodeURIComponent(this.canAcceptValue)}`;

            openModalByUrl(url).then(controller => {
                const template = controller.element.querySelector('template');
                if (!template) {
                    console.error('Template not found in modal content');
                    return;
                }

                const content = template.innerHTML;
                const iframe = controller.element.querySelector('iframe');
                if (!iframe) {
                    console.error('Iframe not found in modal content');
                    return;
                }

                //setTimeout needed for Firefox to display content
                setTimeout(() => {
                    if (iframe.contentWindow && iframe.contentWindow.document.body) {
                        iframe.contentWindow.document.body.style.margin = '0';
                        iframe.contentWindow.document.body.style.padding = '0';
                        iframe.contentWindow.document.body.innerHTML = content;
                        iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';

                        const acceptButton = controller.element.querySelector('.accept-contract');
                        if (acceptButton) {
                            acceptButton.addEventListener('click', () => {
                                controller.close();
                                if (checkbox) {
                                    checkbox.checked = true;
                                }
                            });
                        }
                    } else {
                        console.error('Iframe content window or body not available');
                    }
                }, 0);
            }).catch(error => {
                console.error('Error opening modal:', error);
                if (checkbox) {
                    checkbox.checked = false;
                }
            });
        }
    }
}
